<button *ngFor="let option of options"
        type="button"
        class="pill"
        pButton
        [class.active]="option.value === activeValue"
        (click)="select(option.value)"
        [attr.aria-pressed]="option.value === activeValue"
        [attr.data-testid]="'pill-toggle-btn-' + option.value">
  <ng-container *ngTemplateOutlet="optionTemplate || defaultTemplate; context: { $implicit: option }"></ng-container>
</button>

<ng-template #defaultTemplate
             let-option>
  {{ option.label }}
</ng-template>
